import { _ as _root } from "./auth-service-tools993.js";
var root = _root;
var coreJsData = root["__core-js_shared__"];
var _coreJsData = coreJsData;
export { _coreJsData as _ };